module.exports = __webpack_public_path__ + "img/FR14328.a37641c6.png";